import { useEffect } from "react"
import { newsModalsSocket } from "store/apis/infoModalsAPI/infoModals.api"
import { INFO_MODAL_TYPE, INewsMessage } from "store/apis/infoModalsAPI/types"
import { useModal } from "context/ModalsContext"
import i18n from "utils/i18next"
import { useCheckNews } from "./useCheckNews"
import { useCheckTutorial } from "./useCheckTutorial"

export const useNewsFeed = () => {
  const { openModal } = useModal()
  const checkNews = useCheckNews()
  const checkTutorial = useCheckTutorial()

  useEffect(() => {
    const handleMessage = (message: INewsMessage) => {
      openModal({
        type: "newsFeed",
        params: { message }
      })
    }

    newsModalsSocket.init(
      INFO_MODAL_TYPE.NEWS_FEED,
      i18n.language,
      handleMessage
    )

    const onLanguageChanged = async (lng: string) => {
      if (!(await checkTutorial())) return

      checkNews()

      newsModalsSocket.disconnect()
      newsModalsSocket.init(INFO_MODAL_TYPE.NEWS_FEED, lng, handleMessage)
    }

    i18n.on("languageChanged", onLanguageChanged)

    return () => {
      i18n.off("languageChanged", onLanguageChanged)
      newsModalsSocket.disconnect()
    }
  }, [])
}
